export default function () {
  return {
    current: {
      id: '',
      name: '',
      acronym: '',
      description: '',
      parent: null,
      resources: []
    },
    update: {
      id: '',
      name: '',
      acronym: '',
      description: '',
      parent: null
    },
    list: []
  }
}
